import { css } from '@emotion/react';
import theme from '../../config/theme';

const global = css`
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  html {
    text-rendering: optimizeLegibility;
    overflow-x: hidden;
    box-sizing: border-box;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* font-size: 10px; */
  }
  #___gatsby {
    min-height: calc(100vh - 9rem);
  }
  a {
    transition: color 0.5s;
    text-decoration: none;
  }
  a:hover {
    text-decoration: none;
  }
  .bold {
    font-weight: bold;
  }
  .hidden {
    display: none !important;
  }
  .non-visible {
    visibility: hidden;
    display:none;
    opacity: 0;
  }
  .visible {
    visibility: visible;
    display:block;
    opacity: 1;
    transition: ${theme.transitions.default};
  }
  .no-action {
    pointer-events: none !important;
  }
  .snipcart-modal__container {
    z-index: 10001 !important;
  }
  .snipcart__item__line__header__actions {
    display: flex !important;
  }
  .snipcart__item__line__header__actions img {
    width: 24px !important;
    height: 24px !important;
  }
  .update_icon {
    margin-right: 5px !important;
  }
  .snipcart__button--icon {
    border: none !important;
    padding: 0px !important;
  }
  .error {
    color: red;
    text-align: center;
    margin: 0px;
    margin-bottom: 5px;
  }
  .warning {
    color: ${theme.colors.warning};
    a {
      color: ${theme.colors.warning};
      cursor: pointer;
      text-decoration: underline;
    }
    img {
      margin: 0px;
    }
  }
  .loading-gif.small {
    width: 24px;
  }
  .loading-gif.medium {
    width: 80px;
  }
  .loading-gif.large {
    width: 150px;
  }
  .disabled {
    background-color: ${theme.colors.grey};
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .react-datepicker-popper {
    z-index: 1000000;
  }
  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
  /* Container Design */
  .order-details {
    width: 100%;
    padding: 30px;
    padding-bottom: 75px;
  }

  .order-details__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
  }
  .row {
    display: flex;
  }
  .loading {
    display: flex;
    align-items: center;
  }
  .edit-delete {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .edit-delete p {
    margin-right: 12px;
  }

  .edit-delete p:hover {
    cursor: pointer;
  }

  .deleteIcon {
    height: 20px;
  }

  .deleteIcon:hover {
    cursor: pointer;
  }

  /* Container Details */
  .container__details {
    height: 100%;
    width: 100%;
  }

  .product__details {
    width: 100% !important;
    margin-bottom: 30px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    flex-wrap: wrap;
    @media (max-width: ${theme.breakpoints.m}) {
      margin-bottom: 0px !important;
    }
  }

  .product__details .detail {
    display: flex;
    align-items: center;
    @media (max-width: ${theme.breakpoints.m}) {
      display: none;
    }
  }

  .detail-name {
  }

  .detail-img {
    width: 70px !important;
    margin-right: 15px !important;
  }

  .front-thumbnail {
    width: 150px !important;
    box-shadow: ${theme.shadow.photoCard};
    height: 100%;
    object-fit: scale-down;
    @media (max-width: ${theme.breakpoints.s}) {
      width: 100px !important;
    }
  }
  .quantity-title {
  }

  .quantity-amout {
    margin-top: 13px !important;
  }

  .quantity {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
  }

  /* Curtomer / Delivery Design */
  .cursomerDetails {
    display: flex !important;
    flex-wrap: wrap;
  }
  .cursomerDetails > * {
    margin-right: 70px !important;
    margin-bottom: 30px !important;
    @media (max-width: ${theme.breakpoints.m}) {
      margin-right: 20px !important;
    }

  }
  .cursomerDetails > div:last-of-type {
    margin-right: 0px !important;
  }
  .clientPersonalInfo > p {
    line-height: 20px !important;
  }
  .clientDelivery {
    display: flex !important;
    flex-direction: column !important;
  }

  .deliveryType {
    display: flex !important;
    align-items: center !important;
    margin-bottom: 1rem !important;
  }

  .deliveryType-name {
  }

  .deliveryTime {
    line-height: 30px !important;
  }

  .order-details {
    box-shadow: 4px 5px 11px #a8a3a3 !important;
    background: white !important;
    border-radius: 10px !important;
    width: 100% !important;
    padding: 30px !important;
    margin-bottom: 30px !important;
    @media (max-width: ${theme.breakpoints.s}) {
      border-radius: 0 !important;
    }
  }
  .order-details p {
    font-weight: 600 !important;
  }
  .order-details__header {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    margin-bottom: 30px !important;
  }
  .remove-icon {
    cursor: pointer !important;
  }
  .snipcart__item__line__header__title {
    font-weight: 600 !important;
    font-size: 20px !important;
  }
  .offer {
    display: flex !important;
    flex-direction: column !important;
  }
  .subtitle {
    font-size: 18px !important;
    font-weight: 600 !important;
    margin-bottom: 15px !important;
  }
  .offer-type {
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-around !important;
  }
  .offer-content {
    display: flex !important;
  }
  .notification-message h4 {
    font-weight: 400!important;
  }
  .notification-success, .notification-warning  {
    background-color: ${theme.colors.blue};
  p.singlePrice {
    @media (max-width: ${theme.breakpoints.m}) {
      display: none;
    }
  } 
  p.totalBalance, p.quantity-title {
    font-weight: 700 !important;
  }
`;

export default global;
